import {ReportType} from 'utilities/error-logger';
import {UnableToLoadProductMetadataError} from 'utilities/product';
import {trackDeliveryPromiseError} from 'utilities/tracking';

export function hydratedVariantId() {
  const productMetadata = document.getElementById(
    'shop-promise-product',
  )?.innerHTML;

  try {
    if (productMetadata === undefined) {
      throw new UnableToLoadProductMetadataError();
    }
    const {variantId} = JSON.parse(productMetadata);
    return variantId ? parseInt(variantId, 10) : null;
  } catch (error: unknown) {
    trackDeliveryPromiseError(
      '',
      error as Error,
      'Failure during initial variant id loading',
      ReportType.Investigate,
    );
    return null;
  }
}
